import { LiveEventData, LivePlayerDataEvent } from "./lib/game_snacks/ILiveMultiplayer";
import { Profile } from "./lib/game_snacks/IUser";
import PRNG from "./lib/PRNG";


export default class Session
{
    private _profile: Profile = null;
    private _arrPlayerProfile: Array<Profile> = null;
    private _prng: PRNG = null;
    private _isInvite: boolean = null;
    private _isMessages: boolean = null;
    private _gameType: game_type = null;
    private _arrGameEvent: Array<LiveEventData> = null;
    private _arrRoomEvent: Array<LiveEventData> = null;
    private _privateRoomUrl: string = null;
    private _inactivityElaspedTime: number = null;
    private _preLocalGameProfile: Profile = null;
    private _asyncGameState: IAsyncGameState = null;

    private _isDebug: boolean = null;

    private readonly _kGameRoomSize: number = 2;

    private static _instance: Session = null;


    public set profile( value: Profile ) { this._profile = value; }
    public set room( value: Array<Profile> ) { this._arrPlayerProfile = value; }
    public set prng( value: PRNG ) { this._prng = value; }
    public set isInvite( value: boolean ) { this._isInvite = value; }
    public set isMessages( value: boolean ) { this._isMessages = value; }
    public set gameType( value: game_type ) { this._gameType = value; }
    public set privateRoomUrl( value: string ) { this._privateRoomUrl = value; }
    public set inactivityElapsedTime( value: number ) { this._inactivityElaspedTime = value; }
    public set preLocalGameProfile( value: Profile ) { this._preLocalGameProfile = value; }
    public set asyncGameState( value: IAsyncGameState ) { this._asyncGameState = value; }
    public set isDebug( value: boolean ) { this._isDebug = value; }

    public get profile(): Profile { return this._profile; }
    public get room(): Array<Profile> { return this._arrPlayerProfile; }
    public get prng(): PRNG { return this._prng; }
    public get isInvite(): boolean { return this._isInvite; }
    public get isMessages(): boolean { return this._isMessages; }
    public get gameType(): game_type { return this._gameType; }
    public get privateRoomUrl(): string { return this._privateRoomUrl; }
    public get inactivityElapsedTime(): number { return this._inactivityElaspedTime; }
    public get asyncGameState(): IAsyncGameState { return this._asyncGameState; }
    public get preLocalGameProfile(): Profile { return this._preLocalGameProfile; }
    public get isDebug(): boolean { return this._isDebug; }
    public get gameEvents(): Array<LiveEventData> { return this._arrGameEvent; }
    public get roomEvents(): Array<LiveEventData> { return this._arrRoomEvent; }
    public get kGameRoomSize(): number { return this._kGameRoomSize; }

    public static get i(): Session
    {
        if ( !Session._instance )
        {
            Session._instance = new Session();
        }

        return Session._instance;
    }

    private constructor() 
    {
        this._isInvite = false;
        this._isMessages = false;
        this._isDebug = false;
        this._inactivityElaspedTime = 0;

        this._arrPlayerProfile = [];
        this._arrGameEvent = [];
        this._arrRoomEvent = [];
    }

    public reset(): void
    {
        if ( this._profile )
        {
            this._profile.isReady = false;
        }
        this._prng = null;
        this._isInvite = false;
        this._isMessages = false,
        this._gameType = null;
        this._privateRoomUrl = null;
        this._inactivityElaspedTime = 0;
        this._asyncGameState = null;

        this._arrPlayerProfile.splice( 0 );
        this._arrGameEvent.splice( 0 );
        this._arrRoomEvent.splice( 0 );
    }
}

export const enum game_type
{
    CLASSIC_MATCHMAKING = 0,
    POINTS_MATCHMAKING,
    CLASSIC_PRIVATE,
    POINTS_PRIVATE,
    CLASSIC_OFFLINE,
    POINTS_OFFLINE,
    CLASSIC_ASYNC
}

export interface IAsyncGameState
{
    playerOwnerId: number;
    arrPlayerProfile: Array<Profile>;
    arrPlayerEventIndex: Array<number>;
    arrPlayerEvent: Array<LiveEventData>;
    arrIsRematchRequested: Array<boolean>;
}